<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfoOrCalculatingAttendance"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
      </div>
      <div class="level-right">
        <router-link :to="{ name: 'List Of Payrolls' }" class="button is-small"
          >Go back to list</router-link
        >
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Employee</label>
          <span v-if="payroll.payrollId">{{ employeeName }}</span>
          <div class="control" v-else>
            <b-autocomplete
              v-model="employeeName"
              size="is-small"
              :data="employees"
              placeholder="Search employees"
              @select="option => (selectedEmployee = option)"
              @input="searchEmployees"
              :loading="isFetchingEmployees"
              v-validate="'required'"
              name="Employee name"
            >
              <template slot="empty">
                <span v-if="isFetchingEmployees">
                  Please wait...
                </span>
                <span v-if="employees.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Employee name')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll Date</label>
          <div class="control">
            <input
              type="date"
              @change="payrollInfoHasChanged"
              v-model="payroll.payrollDate"
              class="input is-small"
              v-validate="'required'"
              name="Payroll date"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Payroll date')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll From</label>
          <div class="control">
            <input
              type="date"
              v-model="payroll.payrollFrom"
              class="input is-small"
              v-validate="'required'"
              name="Payroll from"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Payroll from')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Payroll To</label>
          <div class="control">
            <input
              type="date"
              v-model="payroll.payrollTo"
              class="input is-small"
              v-validate="'required'"
              name="Payroll to"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Payroll to')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <button
              :class="buttonCalculateAttendanceDeduction"
              @click="calculateLateAndAbsence"
            >
              Calculate Additional Pay/Deduction
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Additional Pay"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Overtime</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.overtime"
              readonly
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Holiday Pay</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.holidayPay"
              readonly
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Adjustment</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.adjustment"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Night Differential</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.nightDiff"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Contribution"></div>
    <div class="columns">
      <div class="column">
        <b-checkbox
          size="is-small"
          @change="payrollInfoHasChanged"
          v-model="isInludeContributions"
          >Include Contributions</b-checkbox
        >
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">SSS</label>
          <div class="control">
            <input
              type="text"
              v-model="payroll.sss"
              class="input is-small"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">PagIBIG</label>
          <div class="control">
            <input
              type="text"
              v-model="payroll.pagibig"
              class="input is-small"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">PhilHealth</label>
          <div class="control">
            <input
              type="text"
              v-model="payroll.philhealth"
              class="input is-small"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Attendance Deduction"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Late</label>
          <div class="control">
            <input
              type="number"
              readonly
              v-model="payroll.lateDeduction"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Late De Minimis</label>
          <div class="control">
            <input
              type="number"
              readonly
              v-model="payroll.lateDeductionDeMinimis"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Absence</label>
          <div class="control">
            <input
              type="number"
              readonly
              v-model="payroll.absenceDeduction"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Absence De Minimis</label>
          <div class="control">
            <input
              type="number"
              readonly
              v-model="payroll.absenceDeductionDeMinimis"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Loans"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">SSS Loan</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.sssLoan"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">HDMF Loan</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.hdmfLoan"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Company Salary Loan</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.companySalaryLoan"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="is-divider" data-content="Other Deduction"></div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Medicard/Health Card</label>
          <div class="control">
            <input
              type="number"
              readonly
              @keyup="payrollInfoHasChanged"
              v-model="payroll.medicard"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Others</label>
          <div class="control">
            <input
              type="number"
              @keyup="payrollInfoHasChanged"
              v-model="payroll.others"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Note</label>
          <div class="control">
            <textarea
              type="text"
              v-model="payroll.note"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
                <button class="button is-info is-small" @click="calculateTotal">Calculate</button>
            </div>
        </div> -->
    <div class="vld-parent"></div>
    <h5 class="title is-5">Total Payroll</h5>
    <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label is-small">Withholding Tax</label>
                <div class="control">
                  <input
                    type="number"
                    v-model="payroll.withholdingTax"
                    class="input is-small"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label is-small">Net Basic</label>
                <div class="control">
                  <input
                    type="number"
                    v-model="payroll.netBasic"
                    class="input is-small"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label is-small">Deduction</label>
                <div class="control">
                  <input
                    type="number"
                    v-model="payroll.totalDeduction"
                    class="input is-small"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="field">
            <label class="label is-small">Net Pay</label>
            <div class="control">
              <h4 class="title is-4">{{ payroll.netPay }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button
          :class="buttonSave"
          :disabled="isPayrollAlreadyExists"
          @click="savePayroll"
        >
          Save Payroll
        </button>
        &nbsp;
        <router-link :to="{ name: 'List Of Payrolls' }" class="button is-small"
          >Go back to list</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoadingTotal: false,
      isFullPage: false,
      createOrUpdate: 'Create',
      isTriggerOnce: true,
      isFetchingSavedInfoOrCalculatingAttendance: false,
      payroll: {
        sss: 0,
        pagibig: 0,
        philhealth: 0,
        withholdingTax: 0,
        netBasic: 0,
        totalDeduction: 0,
        netPay: 0,
        lateDeduction: 0,
        lateDeductionDeMinimis: 0,
        absenceDeduction: 0,
        absenceDeductionDeMinimis: 0,
        overtime: 0,
        holidayPay: 0
      },
      employeeName: '',
      employees: [],
      selectedEmployee: 0,
      isFetchingEmployees: false,

      isInludeContributions: false,
      isPayrollAlreadyExists: false,
      buttonSave: appButton.isLoadingSuccess(false),
      buttonCalculateAttendanceDeduction: appButton.isLoadingInfo(false)
    }
  },
  created() {
    const payrollId = this.$route.params.payrollId
    if (payrollId) {
      this.getPayrollById(payrollId)
    }
  },
  methods: {
    payrollInfoHasChanged() {
      if (!this.isFetchingSavedInfoOrCalculatingAttendance) {
        this.isTriggerOnce = true
        this.calculateTotal()
      }
    },
    getPayrollById(id) {
      this.isFetchingSavedInfoOrCalculatingAttendance = true
      axios
        .get(`api/payrolls/${id}`)
        .then(response => {
          response.data.payrollDate = moment(response.data.payrollDate).format(
            'YYYY-MM-DD'
          )
          response.data.payrollFrom = moment(response.data.payrollFrom).format(
            'YYYY-MM-DD'
          )
          response.data.payrollTo = moment(response.data.payrollTo).format(
            'YYYY-MM-DD'
          )

          this.payroll = response.data
          this.isInludeContributions = response.data.inludeContributions
          this.employeeName = response.data.employee

          this.createOrUpdate = `Update Payroll of ${this.employeeName}`
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingSavedInfoOrCalculatingAttendance = false
        })
    },
    searchEmployees: debounce(function() {
      this.isFetchingEmployees = true
      axios
        .get(`api/employees/search-by-name/${this.employeeName}`)
        .then(response => {
          this.employees = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingEmployees = false
        })
    }, 500),
    calculateLateAndAbsence() {
      const id = this.payroll.employeeId
      const dateFrom = this.payroll.payrollFrom
      const dateTo = this.payroll.payrollTo
      if ((id, dateFrom, dateTo)) {
        this.buttonCalculateAttendanceDeduction = appButton.isLoadingInfo(true)
        this.isFetchingSavedInfoOrCalculatingAttendance = true
        const idAndDatePeriod = {
          employeeIdNumber: id,
          dateFrom: dateFrom,
          dateTo: dateTo
        }
        if (this.payroll.payrollId) {
          // If payrollId has value it means, it's in edit mode
          this.getAttendanceDeduction(idAndDatePeriod)
          this.getOvertimeAndHolidayPay(idAndDatePeriod)
        } else {
          axios
            .post(
              'api/payrolls/payroll-exists-by-empid-and-payroll-period',
              idAndDatePeriod
            )
            .then(response => {
              this.isPayrollAlreadyExists = response.data

              if (!this.isPayrollAlreadyExists) {
                // if not exists
                this.getAttendanceDeduction(idAndDatePeriod)
                this.getOvertimeAndHolidayPay(idAndDatePeriod)
                this.getTotalMedicard(id) // id = employee id #
              } else {
                appToast.danger(
                  `Employee's payroll with this payroll period (${dateFrom}-${dateTo}) already exists`
                )
              }
            })
            .catch(error => {
              console.log(error)
            })
            .then(() => {
              this.buttonCalculateAttendanceDeduction = appButton.isLoadingInfo(
                false
              )
              this.isFetchingSavedInfoOrCalculatingAttendance = false
            })
        }
      }
    },
    getTotalMedicard(id) {
      this.isFetchingSavedInfoOrCalculatingAttendance = true
      axios
        .get(`api/payrolls/total-medicard-amount/${id}`)
        .then(response => {
          this.payroll.medicard = response.data
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            appToast.danger(error.response.data)
          }
        })
        .then(() => {
          this.isFetchingSavedInfoOrCalculatingAttendance = false
        })
    },
    getAttendanceDeduction(idAndDatePeriod) {
      axios
        .post('api/attendancedeductions', idAndDatePeriod)
        .then(response => {
          this.payroll.lateDeduction = response.data.late
          this.payroll.lateDeductionDeMinimis = response.data.lateDeminimis
          this.payroll.absenceDeduction = response.data.absence
          this.payroll.absenceDeductionDeMinimis =
            response.data.absenceDeminimis
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.payrollInfoHasChanged()
          this.buttonCalculateAttendanceDeduction = appButton.isLoadingInfo(
            false
          )
          this.isFetchingSavedInfoOrCalculatingAttendance = false
        })
    },
    getOvertimeAndHolidayPay(idAndDatePeriod) {
      axios
        .post('api/overtimeandholidaypays', idAndDatePeriod)
        .then(response => {
          this.payroll.overtime = response.data.overtime
          this.payroll.holidayPay = response.data.holidayPay
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.payrollInfoHasChanged()
          this.buttonCalculateAttendanceDeduction = appButton.isLoadingInfo(
            false
          )
          this.isFetchingSavedInfoOrCalculatingAttendance = false
        })
    },
    calculateTotal() {
      if (this.isTriggerOnce) {
        this.isLoadingTotal = true

        const forPayrollCalculation = {
          overtime: this.payroll.overtime ? this.payroll.overtime : 0,
          holidayPay: this.payroll.holidayPay ? this.payroll.holidayPay : 0,
          adjustment: this.payroll.adjustment ? this.payroll.adjustment : 0,
          nightDiff: this.payroll.nightDiff ? this.payroll.nightDiff : 0,
          lateDeduction: this.payroll.lateDeduction
            ? this.payroll.lateDeduction
            : 0,
          lateDeductionDeMinimis: this.payroll.lateDeductionDeMinimis
            ? this.payroll.lateDeductionDeMinimis
            : 0,
          absenceDeduction: this.payroll.absenceDeduction
            ? this.payroll.absenceDeduction
            : 0,
          absenceDeductionDeMinimis: this.payroll.absenceDeductionDeMinimis
            ? this.payroll.absenceDeductionDeMinimis
            : 0,
          inludeContributions: this.payroll.inludeContributions,
          medicard: this.payroll.medicard ? this.payroll.medicard : 0,
          companySalaryLoan: this.payroll.companySalaryLoan
            ? this.payroll.companySalaryLoan
            : 0,
          sssLoan: this.payroll.sssLoan ? this.payroll.sssLoan : 0,
          hdmfLoan: this.payroll.hdmfLoan ? this.payroll.hdmfLoan : 0,
          others: this.payroll.others ? this.payroll.others : 0,
          employeeId: this.payroll.employeeId,
          payrollFrom: this.payroll.payrollFrom,
          payrollTo: this.payroll.payrollTo
        }

        axios
          .post(`api/payrolls/calculate-payroll`, forPayrollCalculation)
          .then(response => {
            this.payroll.withholdingTax = response.data.withholdingTax
            this.payroll.netBasic = response.data.netBasic
            this.payroll.totalDeduction = response.data.deduction
            this.payroll.netPay = response.data.netPay
          })
          .catch(error => {
            console.log(error)
          })
          .then(() => {
            setTimeout(() => {
              this.isLoadingTotal = false
            }, 500)
          })
        this.isTriggerOnce = false
      }
    },
    savePayroll() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const payrollId = this.payroll.payrollId
          if (payrollId) {
            // Edit
            axios
              .put(`api/payrolls/${payrollId}`, this.payroll)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                appToast.danger(error.response.data)
              })
              .then(() => {
                this.$nextTick(() => {
                  this.$validator.reset()
                })
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          } else {
            // Create
            axios
              .post(`api/payrolls`, this.payroll)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(() => {
                this.default()
              })
          }
        }
      })
    },
    default() {
      this.$nextTick(() => {
        this.$validator.reset()
      })

      this.isLoadingTotal = false
      this.isFullPage = false
      this.createOrUpdate = 'Create'
      this.isTriggerOnce = true
      this.isFetchingSavedInfoOrCalculatingAttendance = false
      this.payroll = {
        sss: 0,
        pagibig: 0,
        philhealth: 0,
        withholdingTax: 0,
        netBasic: 0,
        totalDeduction: 0,
        netPay: 0,
        lateDeduction: 0,
        lateDeductionDeMinimis: 0,
        absenceDeduction: 0,
        absenceDeductionDeMinimis: 0
      }
      this.employeeName = ''
      this.employees = []
      this.selectedEmployee = 0
      this.isFetchingEmployees = false
      this.isInludeContributions = false
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.buttonCalculateAttendanceDeduction = appButton.isLoadingInfo(false)
    }
  },
  watch: {
    isInludeContributions() {
      const isInludeContributions = this.isInludeContributions
      this.payroll.inludeContributions = isInludeContributions

      if (isInludeContributions) {
        const employeeId = this.payroll.employeeId
        if (employeeId) {
          axios
            .get(`api/contributions/${employeeId}`)
            .then(response => {
              this.payroll.sss = response.data.sss
              this.payroll.pagibig = response.data.pagIbig
              this.payroll.philhealth = response.data.philHealth
            })
            .catch(error => {
              console.log(error)
            })
        }
      } else {
        this.payroll.sss = 0
        this.payroll.pagibig = 0
        this.payroll.philhealth = 0
      }

      this.payrollInfoHasChanged()
    },
    isPayrollAlreadyExists() {
      if (this.isPayrollAlreadyExists) {
      }
    },
    selectedEmployee() {
      if (this.selectedEmployee) {
        this.payroll.employeeId = this.selectedEmployee.id
      } else {
        this.default()
      }
    }
  }
}
</script>
